const locale = {
	DASHBOARDS: 'Dashboards',
	DASHBOARD_USER: 'User Dashboard',

	COMPANY_INFO: 'Company Info',
	ORGANIZATION_CHART: 'Organization Chart',
	DASHBOARD_KPIS: 'KPIs Dashboard',
	DASHBOARD_POWERBI_STATS: 'PowerBI stats',

	REGISTRIES: 'Registries',
	MAILS: 'Mail Addresses',
	PHONENUMBERS: 'Phone numbers',
	SOCIALNETWORKS: 'Social Networks',

	COMMUNICATIONS_MANAGEMENT: 'Communications Management',
	COMMUNICATIONS: 'Communications',
	REQUESTS: 'Requests',
	LEAVE: 'Leave',

	TRAINING: 'Employees Training',
	SKILLS: 'Skills',
	COURSES: 'Courses',
	SALES: 'Sales',
	COMMERCIALCAMPAIGNS: 'Commercial Campaigns',
	OPPORTUNITIES: 'Opportunities',
	CONTRACTS: 'Contracts',
	ORDERS: 'Orders',
	INVOICES: 'Invoices',

	MANAGEMENT: 'Task Management',
	PROJECTS: 'Projects',
	ACTIVITIES: 'Activities',
	WORKREPORTS: 'Work Reports',
	CHRONOLOGY: 'Chronology',
	TICKETS: 'Tickets',
	PHONECALLS: 'Phone Calls',

	SYSTEM: 'System',
	DOCUMENTS_FOLDERS: 'Documents Folders',
	USERS: 'Users',
	GROUPS: 'Groups',
	RECYCLE_BIN: 'Recycle Bin',
	TAGS: 'Tags',
	LOGS: 'System Logs',
	SYSTEM_TABLES: 'System tables',
	PERMISSIONS_MANAGEMENT: 'Permissions Management',
	SETTINGS: 'Settings'
};

export default locale;
